import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularTrade: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_trade"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="trade icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M15.5158 21.6303C15.6824 21.8546 15.948 21.9998 16.2472 21.9998C16.5449 21.9998 16.8094 21.856 16.9762 21.6336C17.0022 21.6102 17.0274 21.5853 17.0517 21.5589L20.2542 18.0734C20.5972 17.7002 20.5753 17.117 20.2053 16.771C19.8354 16.4249 19.2574 16.447 18.9144 16.8203L17.1607 18.7289V2.92188C17.1607 2.41288 16.7517 2.00024 16.2472 2.00024C15.7427 2.00024 15.3337 2.41288 15.3337 2.92188V18.7276L13.5812 16.8203C13.2382 16.447 12.6602 16.4249 12.2903 16.771C11.9203 17.117 11.8984 17.7002 12.2414 18.0734L15.4439 21.5589C15.467 21.584 15.491 21.6078 15.5158 21.6303Z" />
        <path d="M7.01992 2.36968C7.18654 2.14538 7.45215 2.00025 7.75136 2.00025C8.0491 2.00025 8.31357 2.14396 8.48034 2.36639C8.50639 2.38983 8.5316 2.41474 8.55585 2.44113L11.7584 5.92656C12.1014 6.29985 12.0795 6.88298 11.7095 7.22903C11.3395 7.57507 10.7615 7.55299 10.4185 7.17971L8.66485 5.27109V21.0781C8.66485 21.5871 8.25586 21.9998 7.75136 21.9998C7.24685 21.9998 6.83787 21.5871 6.83787 21.0781V5.27238L5.08536 7.17971C4.74237 7.55299 4.1644 7.57507 3.79442 7.22903C3.42443 6.88298 3.40255 6.29985 3.74553 5.92656L6.94806 2.44113C6.97117 2.41598 6.99516 2.39216 7.01992 2.36968Z" />
      </svg>
    </span>
  );
};

export { RegularTrade };
